var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66797 11.3333V12.6667C2.66797 13.0203 2.80844 13.3594 3.05849 13.6095C3.30854 13.8595 3.64768 14 4.0013 14H12.0013C12.3549 14 12.6941 13.8595 12.9441 13.6095C13.1942 13.3594 13.3346 13.0203 13.3346 12.6667V11.3333M4.66797 6L8.0013 2.66666M8.0013 2.66666L11.3346 6M8.0013 2.66666V10.6667",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0885aa0bbf9f360dc291d2d570e21404.svg";
export { ForwardRef as ReactComponent };